var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wine-box"},[_c('main',[_c('Header'),_c('Itens',{staticClass:"itens"}),_c('SubTotal',{staticClass:"subtotal"})],1),_c('div',{staticClass:"backdrop",on:{"click":_vm.toggleWineBox}})])}
var staticRenderFns = []

export { render, staticRenderFns }